import { Trans, useTranslation } from '@dagens/frontend-i18n';
import Typography from '@carrot-deprecated/typography';
import Callout from '@carrot-deprecated/callout';
import Container from '@carrot-deprecated/container';
import Theme from '@carrot-deprecated/theme';
import { useAppSelector } from '_common/hooks/reduxHooks';
import { ButtonLink } from '_common/components/button/Button.style';
import { Producer } from 'types/Producer';
import { B } from 'utils/fonts';

type ProducerCalloutProps = {
  userId?: string;
  producer: Producer;
};

const ProducerCallout = ({ userId, producer }: ProducerCalloutProps) => {
  const { t } = useTranslation();
  const { dagensId } = useAppSelector(({ auth: { dagensId } }) => {
    return {
      dagensId
    };
  });

  if (userId !== producer._id) return null;

  const producerUrl = `${window.location.host}/${producer.handle}`;

  return (
    <Callout mb="s">
      <>
        <Typography variant="paragraphBold" as="p">
          {t('common:OnlyVisibleForProducerCalloutHeader')}
        </Typography>
        <Typography variant="paragraph" my="s">
          {t('common:OnlyVisibleForProducerCalloutText')}
        </Typography>
        <Typography variant="paragraph" my="s">
          <Trans
            t={t}
            i18nKey="common:OnlyVisibleForProducerCalloutTextWithProducerUrl"
            values={{ producerUrl }}
            components={{ B: <B /> }}
          />
        </Typography>
        <Container flex justify="flex-start" alignItems="baseline">
          {producer.handle.toLowerCase() === dagensId?.toLowerCase() ? (
            <>
              <ButtonLink
                to="/profile"
                variant="secondary"
                mt={Theme.Spacings.xs}
                mr={Theme.Spacings.xs}
              >
                {t('common:SetCustomShopLink')}
              </ButtonLink>
              <ButtonLink
                to="/my-products"
                variant="borderless"
                mt={Theme.Spacings.xs}
              >
                {t('common:UpdateProducts')}
              </ButtonLink>
            </>
          ) : (
            <>
              <ButtonLink
                to="/my-products"
                variant="secondary"
                mt={Theme.Spacings.xs}
              >
                {t('common:UpdateProducts')}
              </ButtonLink>
              <ButtonLink
                to="/profile"
                variant="borderless"
                mt={Theme.Spacings.xs}
              >
                {t('common:EditInformation')}
              </ButtonLink>
            </>
          )}
        </Container>
      </>
    </Callout>
  );
};

export default ProducerCallout;
